import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import bannerimage from "../../assets/images/inner-banner-2.jpg";  

export default function PrivacyPolicy() {
  useEffect(() => {
    document.title = "Privacy Policy";
    window.scroll(0,0)
  }, []);
return ( 

<div>

<section className='inner-banner'>
    <img src={bannerimage} alt="call" className="img-fluid" />
        <div className="inner-caption">
        <div className="container">
            <div className="row">
                <div className="caption-details bnr-txt">
                    <ul>
                      <li><Link to='/'> Home </Link></li>
                      <li> / </li>  
                      <li> Privacy Policy </li>
                    </ul>
                    <h1>
                    Can be started over night, But It<br></br> takes years to build an Institution.
                    </h1>
                </div>
            </div>
        </div>
        </div>
</section>  

<section className='people-function phsiyo-therphy'> 
<div className="container">
    <div className="row"> 
        <div className="col-lg-12">
                <div className="common-heading">
               <h2> <span className='inlne'>Privacy</span> Policy</h2>
                </div>
                 <p>This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII) is being used online. Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with our website.</p>
                 <div className="special-instruction pol-icy mb-2">
                  <h3>What personal information do we collect from the people that visit our blog, website or app?</h3>
                  </div>
                  <p>When enquiring or filling forms on our site, as appropriate, you may be asked to enter your name, email address, phone number or other details to help you with your experience.</p>
                 <div className="special-instruction pol-icy mb-2">
                  <h3>When do we collect information?</h3>
                  </div>
                  <p>We collect information from you when you subscribe to a newsletter, fill out a form to book lab tests or enter information on our site to provide us with feedback on our products or services.</p>
                  <div className="special-instruction pol-icy mb-2">
                  <h3>How do we use your information?</h3>
                  </div>
                  <p>We may use the information we collect from you when you enquire, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:</p>
                  <p>To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested.</p>
                  <div className="detilos-expl indication-details policeis-migrate">
                  <ul>
                  <li>To improve our website in order to serve you better.</li>
                  <li>To allow us to better service you in responding to your customer service requests.</li>
                  <li>To send periodic emails regarding your order or other products and services.</li>
                  <li>To follow up with them after correspondence (live chat, email or phone inquiries)</li>
                  </ul>
                  </div>
                  <div className="special-instruction pol-icy mb-2">
                  <h3>How do we protect your information?</h3>
                  </div>
                  <p>Our website is scanned on a regular basis for security holes and known vulnerabilities in order to make your visit to our site as safe as possible. We use regular Malware Scanning.
                  <br/>  
                  Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. We implement a variety of security measures when a user enters, submits, or accesses their information to maintain the safety of your personal information.</p>
                  <div className="special-instruction pol-icy mb-2">
                  <h3>Do we use 'cookies'?</h3>
                  </div>
                  <p>Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser (if you allow) that enables the site's or service provider's systems to recognize your browser and capture and remember certain information. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.</p> 
               
                <div className="special-instruction pol-icy mb-2">
                <h3>We use cookies to:</h3>
                </div>
                <div className="detilos-expl indication-details policeis-migrate">
                <ul>
                <li>Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf.</li>
                <li>You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser's Help Menu to learn the correct way to modify your cookies.</li>
                <li>If you turn cookies off, some features will be disabled. It won't affect the user's experience that make your site experience more efficient and may not function properly.</li>
                </ul>
                </div>
                <div className="special-instruction pol-icy mb-2">
                <h3>Third-party disclosure</h3>
                </div>   
                <p>We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information unless we provide users with advance notice. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when its release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property or safety.</p>
                <p>However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.</p>
                <div className="special-instruction pol-icy mb-2">
                <h3>Google’s Advertising Principles</h3>
                </div> 
                <p>Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users.</p>
                <p><b>https://support.google.com/adwordspolicy/answer/1316548?hl=en</b></p>
                <div className="special-instruction pol-icy mb-2">
                <h3>We use Google AdSense Advertising on our website.</h3>
                </div> 
                <p>Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.</p>
                <p>We have implemented the following:</p>
                <div className="detilos-expl indication-details policeis-migrate">
                <ul>
                <li>Remarketing with Google AdSense</li>
                <li>Google Display Network Impression Reporting</li>
                <li>Demographics and Interests Reporting</li>
                <li>Double-Click Platform Integration</li>
                </ul>
                </div>
                <p>We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website.</p>
                <div className="special-instruction pol-icy mb-2">
                <h3>Opting out</h3>
                </div>
                <p>Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics Opt Out Browser add on.</p>
                <div className="special-instruction pol-icy mb-2">
                <h3>For Children</h3>
                </div>
                <p>We do not specifically market to children under the age of 13 years old.</p>
                <div className="special-instruction pol-icy mb-2">
                <h3>Newsletters - Free of SPAMs</h3>
                </div>
                <p>To be in accordance with No Spam Principle, we agree to the following:</p>
                <div className="detilos-expl indication-details policeis-migrate">
                <ul>
                <li>Not use false or misleading subjects or email addresses.</li>
                <li>Identify the message as an advertisement in some reasonable way.</li>
                <li>Include the physical address of our business or site headquarters.</li>
                <li>Monitor third-party email marketing services for compliance, if one is used.</li>
                <li>Honor opt-out/unsubscribe requests quickly.</li>
                <li>Allow users to unsubscribe by using the link at the bottom of each email.</li>
                </ul>
                </div>
                <p>If at any time you would like to unsubscribe from receiving future emails, follow the instructions at the bottom of each email and we will promptly remove you from ALL correspondence.</p>
                <div className="special-instruction pol-icy mb-2">
                <h3>Contacting Us</h3>
                </div>
                <p>If there are any questions regarding this privacy policy, you may contact us on 18004251974. </p>
                </div>
    </div>
</div>
</section>     
    </div>
  )
}
